import React, { useState, useEffect } from "react";
import axios from "axios";
import { ReactSession } from "react-client-session";
import "./BaaHam_ContentproductionUser_IntroductionTable.css";
import moment from "jalali-moment";

//     index: index,
//                     image: item.image,
//                     text: item.text,
//                     title: item.title,
//                     tags: item.tags,
//                     writer: item.writer,
//                     isDeleted: item.isDeleted,
//                     active: item.active,
//                     createdAt: item.createdAt,
//                     updatedAt: item.updatedAt,
// id: item.id,

function BaaHam_ContentproductionUser_IntroductionTable(props) {
    const { Tables } = props;
    // console.log(Tables);

    function deleteBlog(blogId) {
        // console.log(blogId);
        var blogDialogWait = document.getElementById("blogDialogWait");
        var blogDialogOk = document.getElementById("blogDialogOk");
        var blogDialogErr = document.getElementById("blogDialogErr");

        blogDialogWait.style.display = "inline-block";
        blogDialogOk.style.display = "none";
        blogDialogErr.style.display = "none";
        axios
            .delete("https://hammaskan.ir:8443/api/posts/" + blogId)
            .then((res) => {
                // console.log(res);
                blogDialogWait.style.display = "none";
                blogDialogOk.style.display = "inline-block";
                blogDialogErr.style.display = "none";
                props.onchange("change");
            })
            .catch((error) => {
                // console.log(error);
                blogDialogWait.style.display = "none";
                blogDialogOk.style.display = "none";
                blogDialogErr.style.display = "inline-block";
                if (error.response.data.message) {
                    blogDialogErr.textContent = error.response.data.message;
                } else {
                    blogDialogErr.textContent = "امکان ارسال پیامک وجود ندارد";
                }
            });
    }

    return (
        <div>
            <div className="labelLSGN" id="blogDialogWait" style={{ display: "none", fontSize: "14px", backgroundColor: "#1B9CFC", color: "snow", width: "100%", padding: "12px 0", borderRadius: "6px", margin: "12px 0" }}>
                لطفا کمی صبر کنید ...
            </div>
            <div className="labelLSGN" id="blogDialogOk" style={{ display: "none", fontSize: "14px", backgroundColor: "#06d6a0", color: "snow", width: "100%", padding: "12px 0", borderRadius: "6px", margin: "12px 0" }}>
                مطلب مورد نظر حذف شد
            </div>
            <div className="labelLSGN" id="blogDialogErr" style={{ display: "none", fontSize: "14px", backgroundColor: "tomato", color: "snow", width: "100%", padding: "12px 0", borderRadius: "6px", margin: "12px 0" }}>
                --
            </div>
            <div className="BaaHam_MU_IntroductionTable">
                <div className="BaaHam_MU_IntroductionTableRow">
                    <div className="BaaHam_MU_IntroductionTableItemTitle">
                        <span>ردیف</span>
                    </div>
                    {Tables.map((Table, index) => {
                        return <span className="BaaHam_MU_IntroductionTableItemContent">{index + 1}</span>;
                    })}
                </div>
                <div className="BaaHam_MU_IntroductionTableItem">
                    <div className="BaaHam_MU_IntroductionTableItemTitle">نام</div>
                    {Tables.map((Table) => {
                        return (
                            <span className="BaaHam_MU_IntroductionTableItemContent">
                                <img style={{ width: "32px", height: "32px" }} src={"https://hammaskan.ir:8443/api/data/image/?imagePath=" + Table.image} />
                            </span>
                        );
                    })}
                </div>
                <div className="BaaHam_MU_IntroductionTableItem">
                    <div className="BaaHam_MU_IntroductionTableItemTitle">عنوان</div>
                    {Tables.map((Table) => {
                        return <span className="BaaHam_MU_IntroductionTableItemContent">{Table.title}</span>;
                    })}
                </div>
                <div className="BaaHam_MU_IntroductionTableItem">
                    <div className="BaaHam_MU_IntroductionTableItemTitle">زمان ایجاد</div>
                    {Tables.map((Table) => {
                        return <span className="BaaHam_MU_IntroductionTableItemContent">{moment(Table.createdAt).locale("fa").format("YYYY/MM/DD")}</span>;
                    })}
                </div>
                <div className="BaaHam_MU_IntroductionTableItem">
                    <div className="BaaHam_MU_IntroductionTableItemTitle">به روز رسانی</div>
                    {Tables.map((Table) => {
                        return <span className="BaaHam_MU_IntroductionTableItemContent">{moment(Table.updatedAt).locale("fa").format("YYYY/MM/DD")}</span>;
                    })}
                </div>
                <div className="BaaHam_MU_IntroductionTableItem">
                    <div className="BaaHam_MU_IntroductionTableItemTitle">ویرایش</div>
                    {Tables.map((Table) => {
                        return (
                            <span className="BaaHam_MU_IntroductionTableItemContent">
                                <div style={{ width: "42px", height: "24px", backgroundColor: "blueviolet", color: "snow", padding: "5px 8px 2px 8px", borderRadius: "6px", textAlign: "center", cursor: "pointer" }}>ویرایش</div>
                            </span>
                        );
                    })}
                </div>
                <div className="BaaHam_MU_IntroductionTableItem">
                    <div className="BaaHam_MU_IntroductionTableItemTitle">حذف</div>
                    {Tables.map((Table) => {
                        return (
                            <span className="BaaHam_MU_IntroductionTableItemContent">
                                <div onClick={() => deleteBlog(Table.id)} style={{ width: "42px", height: "24px", backgroundColor: "tomato", color: "snow", padding: "5px 8px 2px 8px", borderRadius: "6px", textAlign: "center", cursor: "pointer" }}>
                                    حذف
                                </div>
                            </span>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default BaaHam_ContentproductionUser_IntroductionTable;
